/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import i18n from "@/i18ns/i18n.js";
const state = {
  gridConfigDefault: {
    UserGrid: [
      {
        FieldName: "FullName",
        Caption: "Họ và tên",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "JobTitleName",
        Caption: "Chức vụ",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "OrganizationUnitName",
        Caption: "Phòng ban",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "OrganizationName",
        Caption: "Đơn vị",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "Email",
        Caption: "Email",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "UserGroupName",
        Caption: "Nhóm người dùng",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Mobile",
        Caption: "Số điện thoại",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "WorkPhone",
        Caption: "SĐT cơ quan",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
        Tooltip: "Số điện thoại cơ quan",
      },
      {
        FieldName: "Status",
        Caption: "Trạng thái",
        DataType: "custom-center",
        IsVisible: true,
        SubSystemCode: "UserGrid",
        Width: 200,
        IsSort: true,
      },
    ],
    ListAllGrid: [
      {
        FieldName: "ProcessExecutionCode",
        Caption: i18n.t("i18nCommon.PROCESS_CODE"),
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 120,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: "i18nCommon.PROCESS_CONFIG_NAME",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "StepExecutionName",
        Caption: i18n.t("i18nCommon.STEPEXECUTIONNAME"),
        KeyLanguage: "i18nCommon.STEPEXECUTIONNAME",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Executor",
        Caption: i18n.t("i18nCommon.ExecutorName"),
        KeyLanguage: "i18nCommon.ExecutorName",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "PublishDate",
        Caption: i18n.t("i18nCommon.PROCESS_PUBLISH_DATE"),
        KeyLanguage: "i18nCommon.PROCESS_PUBLISH_DATE",
        DataType: "date",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Deadline",
        Caption: i18n.t("i18nCommon.PROCESS_DEADLINE"),
        KeyLanguage: "i18nCommon.PROCESS_DEADLINE",
        DataType: "custom-deep",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],
    ListMyNeedToDo: [
      {
        FieldName: "ProcessExecutionCode",
        Caption: i18n.t("i18nCommon.PROCESS_CODE"),
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 120,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "StepExecutionName",
        Caption: i18n.t("i18nCommon.STEPEXECUTIONNAME"),
        KeyLanguage: "i18nCommon.STEPEXECUTIONNAME",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      }, {
        FieldName: "Executor",
        Caption: i18n.t("i18nCommon.ExecutorName"),
        KeyLanguage: "i18nCommon.ExecutorName",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "PublishDate",
        Caption: i18n.t("i18nCommon.PROCESS_PUBLISH_DATE"),
        KeyLanguage: "i18nCommon.PROCESS_PUBLISH_DATE",
        DataType: "date",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Deadline",
        Caption: i18n.t("i18nCommon.PROCESS_DEADLINE"),
        KeyLanguage: "i18nCommon.PROCESS_DEADLINE",
        DataType: "custom-deep",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],
    ListMyCreated: [
      {
        FieldName: "ProcessExecutionCode",
        Caption: i18n.t("i18nCommon.PROCESS_CODE"),
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 120,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "StepExecutionName",
        Caption: i18n.t("i18nCommon.STEPEXECUTIONNAME"),
        KeyLanguage: "i18nCommon.STEPEXECUTIONNAME",
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "PublishDate",
        Caption: i18n.t("i18nCommon.PROCESS_PUBLISH_DATE"),
        KeyLanguage: "i18nCommon.PROCESS_PUBLISH_DATE",
        DataType: "date",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "Executor",
        Caption: i18n.t("i18nCommon.ExecutorName"),
        KeyLanguage: "i18nCommon.ExecutorName",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 200,
        IsSort: true,
      },

      {
        FieldName: "col_Deadline",
        Caption: i18n.t("i18nCommon.PROCESS_DEADLINE"),
        KeyLanguage: "i18nCommon.PROCESS_DEADLINE",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },

      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],
    ListImplementd: [
      {
        FieldName: "ProcessExecutionCode",
        Caption: i18n.t("i18nCommon.PROCESS_CODE"),
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 120,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "StepExecutionName",
        Caption: i18n.t("i18nCommon.STEPEXECUTIONNAME"),
        KeyLanguage: "i18nCommon.STEPEXECUTIONNAME",
        DataType: "text",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Executor",
        Caption: i18n.t("i18nCommon.ExecutorName"),
        KeyLanguage: "i18nCommon.ExecutorName",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "PublishDate",
        Caption: i18n.t("i18nCommon.PROCESS_PUBLISH_DATE"),
        KeyLanguage: "i18nCommon.PROCESS_PUBLISH_DATE",
        DataType: "date",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Deadline",
        Caption: i18n.t("i18nCommon.PROCESS_DEADLINE"),
        KeyLanguage: "i18nCommon.PROCESS_DEADLINE",
        DataType: "custom-deep",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],
    ListRelatedToMe: [
      {
        FieldName: "ProcessExecutionCode",
        Caption: i18n.t("i18nCommon.PROCESS_CODE"),
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 120,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "StepExecutionName",
        Caption: i18n.t("i18nCommon.STEPEXECUTIONNAME"),
        KeyLanguage: "i18nCommon.STEPEXECUTIONNAME",
        DataType: "text",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Executor",
        Caption: i18n.t("i18nCommon.ExecutorName"),
        KeyLanguage: "i18nCommon.ExecutorName",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 200,
        IsSort: true,
      },
      {
        FieldName: "PublishDate",
        Caption: i18n.t("i18nCommon.PROCESS_PUBLISH_DATE"),
        KeyLanguage: "i18nCommon.PROCESS_PUBLISH_DATE",
        DataType: "date",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Deadline",
        Caption: i18n.t("i18nCommon.PROCESS_DEADLINE"),
        KeyLanguage: "i18nCommon.PROCESS_DEADLINE",
        DataType: "custom-deep",
        IsVisible: false,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],
    ListDraft: [
      {
        FieldName: "CreatedDate",
        Caption: i18n.t("i18nCommon.CREATED_DATE"),
        KeyLanguage: "i18nCommon.CREATED_DATE",
        DataType: "date",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      },
      {
        FieldName: "col_Title",
        Caption: i18n.t("i18nCommon.col_Title"),
        KeyLanguage: "i18nCommon.col_Title",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "ProcessConfigName",
        Caption: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        KeyLanguage: i18n.t("i18nCommon.PROCESS_CONFIG_NAME"),
        DataType: "text",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 300,
        IsSort: true,
      },
      {
        FieldName: "col_Field",
        Caption: i18n.t("i18nCommon.col_Field"),
        KeyLanguage: "i18nCommon.col_Field",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "col_Owner",
        Caption: i18n.t("i18nCommon.col_Owner"),
        KeyLanguage: "i18nCommon.col_Owner",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      // {
      //   FieldName: "Executor",
      //   Caption: i18n.t("i18nCommon.ExecutorName"),
      //   KeyLanguage: "i18nCommon.ExecutorName",
      //   DataType: "custom-deep",
      //   IsVisible: true,
      //   SubSystemCode: "ListAllGrid",
      //   Width: 200,
      //   IsSort: true,
      // },
      {
        FieldName: "col_Priority",
        Caption: i18n.t("i18nCommon.col_Priority"),
        KeyLanguage: "i18nCommon.col_Priority",
        DataType: "custom-deep",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 250,
        IsSort: true,
      },
      {
        FieldName: "Status",
        Caption: i18n.t("i18nCommon.Status"),
        KeyLanguage: "i18nExecute.Status",
        DataType: "custom",
        IsVisible: true,
        SubSystemCode: "ListAllGrid",
        Width: 150,
        IsSort: true,
      }
    ],

  },
  // số liệu màn tổng quan
  requestNeedToDo: 0,
  requestMyCreate: 0,
  requestMyExecute: 0,
  userInfor: null,
  dataJobPosition: null,
  // dữ liệu cơ cấu tổ chức
  dataOrganization: null,

  // dữ liệu cơ cấu tổ chức control
  dataOrganizationCommon: null,
  // dữ liệu cơ cấu tổ chức chứa đơn vị ngưng hoạt động control
  dataOrganizationCommonInactive: null,
  // Danh sách quyền của người dùng
  listRole: null,
  selectedCount: null,
  isEditingMode: false,
  //Trạng thái cây dạng bảng đã mở
  expandedTreeList: {},
  //Danh sách header cột của các màn grid
  gridConfig: {},
  userOptions: {},
  stateLoadListProcess: false,
  isEditable: true,
  listProcesstStatus: [
    {
      ID: 0,
      Value: i18n.t("i18nCommon.DRAFT"),
    },
    {
      ID: 1,
      Value: i18n.t("i18nCommon.IN_PROGRESS"),
    },
    {
      ID: 2,
      Value: i18n.t("i18nCommon.COMPLETED"),
    },
    {
      ID: 3,
      Value: i18n.t("i18nCommon.REJECTED"),
    },
  ],
  listProcessPriority: [
    {
      ID: 1,
      Value: i18n.t("i18nCommon.LOW")
    },
    {
      ID: 2,
      Value: i18n.t("i18nCommon.NORMAL")
    },
    {
      ID: 3,
      Value: i18n.t("i18nCommon.HIGHT")
    }
  ],
  activeMenu: null,
  companyConflicts: [], // Danh sách bị trùng
  companyList: [], // Danh sách đơn vị đăng ký kết nối
  companyInfos: [], // Danh sách đơn vị 
};

export default state;
